import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { deserializeQuery } from 'utils';

const useQueryUrlParams = () => {
  const { search } = useLocation();
  const [query, setQuery] = useState(deserializeQuery(search));
  useEffect(() => {
    if (search) {
      setQuery(deserializeQuery(search));
    }
    if (!search) {
      setQuery({});
    }
  }, [search]);

  return query;
};

export default useQueryUrlParams;
